import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the PWA service worker so browsers surface the "Install app" prompt.
// We register after `load` to keep initial paint fast.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => {
        // Non-fatal — SW failures should never break the app.
        // eslint-disable-next-line no-console
        console.warn('[PWA] Service worker registration failed:', err);
      });
  });
}
